import Vue from 'vue'

const resource = 'account'

const withdraw = () => Vue.axios.post(`${resource}/withdraw`)

export default {
  withdraw
}



// WEBPACK FOOTER //
// ./src/api/account.js